import { openDB } from 'idb';
import type { StateStorage } from 'zustand/middleware';

const DATABASE_NAME = 'donelit-offline-storage';
const DATABASE_VERSION = 1;
const STORE_NAME = 'zustand';

const databasePromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
  upgrade(database) {
    if (!database.objectStoreNames.contains(STORE_NAME)) {
      database.createObjectStore(STORE_NAME);
    }
  },
});

export const indexedDbStorage: StateStorage = {
  async getItem(name) {
    const database = await databasePromise;
    const value = await database.get(STORE_NAME, name);

    if (typeof value === 'string') {
      return value;
    }

    // One-time migration path for users who already have data in localStorage.
    const localStorageValue = localStorage.getItem(name);
    if (localStorageValue !== null) {
      await database.put(STORE_NAME, localStorageValue, name);
    }

    return localStorageValue;
  },

  async setItem(name, value) {
    const database = await databasePromise;
    await database.put(STORE_NAME, value, name);
  },

  async removeItem(name) {
    const database = await databasePromise;
    await database.delete(STORE_NAME, name);
  },
};
